import { createSelector } from "@ngrx/store";
import { announcementAdapter } from "../reducers/data/announcements.reducer";
import { selectDataSlice } from "./data-slice.selector";

export const selectAnnouncements = createSelector(selectDataSlice, (state) => state.announcements);

export const { selectEntities: selectAnnouncementEntities, selectAll: selectAllAnnouncements } =
	announcementAdapter.getSelectors(selectAnnouncements);

export const selectLatestUnnanouncedAnnouncement = createSelector(selectAllAnnouncements, (announcements) => {
	const unacknowledgedAnnouncements = announcements.filter((announcement) => !announcement.announced);
	return unacknowledgedAnnouncements?.length ? unacknowledgedAnnouncements[0] : undefined;
});

export const selectLatestUnreadAnnouncement = createSelector(selectAllAnnouncements, (announcements) => {
	const unreadAnnouncements = announcements.filter((announcement) => !announcement.read);
	return unreadAnnouncements?.length ? unreadAnnouncements[0] : undefined;
});

export const selectAmountOFUnreadAnnouncements = createSelector(selectAllAnnouncements, (announcements) => {
	const unreadAnnouncements = announcements.filter((announcement) => !announcement.read);
	return unreadAnnouncements?.length || 0;
});

export const selectAnnouncementByVersion = (version: string) =>
	createSelector(selectAllAnnouncements, (announcements) => {
		return announcements.find((announcement) => announcement.version === version);
	});
